import { escapeCsvValue } from './csvValidator';

const UUID_REGEX = /\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/gi;
const ERROR_DOWNLOAD_HEADERS = ['lineNumber', 'errorType', 'message'];

export const sanitizeErrorMessage = (message) => {
  if (!message) {
    return '';
  }
  const withoutUuids = String(message).replace(UUID_REGEX, '');
  return withoutUuids
    .replace(/\s*:\s*:\s*/g, ': ')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s*:\s*$/g, '')
    .trim();
};

export const getErrorSamples = (upload) => {
  const samples = upload?.errorSamples || upload?.errorDetails || upload?.errors;
  return Array.isArray(samples) ? samples : [];
};

export const normalizeErrorSample = (entry) => {
  if (typeof entry === 'string') {
    const match = entry.match(/row\s+(\d+)\s*[:\-]\s*(.+)/i);
    const lineNumber = match ? match[1] : '';
    const message = sanitizeErrorMessage(match ? match[2] : entry) || 'Error';
    return {
      lineNumber,
      errorType: 'ERROR',
      message,
    };
  }
  if (entry && typeof entry === 'object') {
    const lineNumber = entry.lineNumber || entry.rowNumber || entry.row || entry.line || '';
    const message = sanitizeErrorMessage(entry.message || entry.error || entry.detail || '') || 'Error';
    const errorType = entry.type || entry.errorType || entry.code || 'ERROR';
    return {
      lineNumber,
      errorType,
      message,
    };
  }
  return null;
};

export const buildErrorCsvContent = (samples = []) => {
  const rows = samples
    .map(normalizeErrorSample)
    .filter(Boolean);
  const lines = [ERROR_DOWNLOAD_HEADERS.join(',')];
  rows.forEach((row) => {
    const line = ERROR_DOWNLOAD_HEADERS
      .map((header) => escapeCsvValue(row[header]))
      .join(',');
    lines.push(line);
  });
  return lines.join('\n');
};

export const buildErrorLines = (upload, limit = 3) => {
  const samples = getErrorSamples(upload);
  if (Array.isArray(samples) && samples.length > 0) {
    return samples.slice(0, limit).map((entry, index) => {
      const normalized = normalizeErrorSample(entry) || {
        lineNumber: '',
        errorType: 'ERROR',
        message: 'Error',
      };
      const lineLabel = normalized.lineNumber || '';
      const message = sanitizeErrorMessage(normalized.message || 'Error') || 'Error';
      const errorType = normalized.errorType || 'ERROR';
      return {
        key: [
          upload?.id || 'upload',
          lineLabel || 'line',
          errorType,
          message,
          index,
        ].join('::'),
        text: lineLabel ? `Row ${lineLabel}: ${message}` : message,
      };
    });
  }
  return [];
};
